import { Injectable } from '@angular/core';
import { Subject, last, map, pipe } from 'rxjs';

import { Quotation, ResponseWrapper } from '@library/common';
import { CacheService } from '@library/core';
import { HttpClient } from '@angular/common/http';
import { IGenericType } from '@library/common/generictype';

@Injectable({
  providedIn: 'root'
})
export class QuotationDetailsService {
  url = 'quotations';

  refresh$: Subject<void> = new Subject();
  
  constructor(
    private cache: CacheService,
    private http: HttpClient,
  ) { }

  load( hawb: string ) {
    return this.cache.request<ResponseWrapper<Quotation<any, any>>, Quotation<any, any>>({
      url: this.url + '/view',
      refresher: this.refresh$,
      params: { id: hawb },
      pipe: pipe(
        map( rw => rw.response.collection[0] ? rw.response.collection[0] : null ),
      ),
      useLambda: true,
    })
    .pipe(
      map( quote => quote ? new Quotation( quote ) : quote ),
    );
  }

  acceptQuote( quoteId: string ) {
    return this.http.patch<IGenericType>(
      this.url + '/status/accept',
      { id: quoteId, reasonCode: '' },
      { reportProgress: true, params: { useLambda: true } } )
    .pipe(
      last(),
      map( rw => rw.response.collection[0] ),
   );
  }

  rejectQuote( quoteId: string, rejectionCode: string ) {
    return this.http.patch<IGenericType>(
      this.url + '/status/reject',
      { id: quoteId, reasonCode: rejectionCode },
      { reportProgress: true, params: { useLambda: true } } )
    .pipe(
      last(),
      map( rw => rw.response.collection[0] ),
   );
  }

  resetDetails(  ) {
    this.cache.clearSet( this.url + '/view' );
  }

  reset() {
    this.cache.clearSet( this.url );
  }

}
